import { $http } from "@/plugins/api";
import { getApiClientUrl } from "@/config/runtimeConfig";
const state = {
  resolutionHistory: [],
};

const getters = {
  resolutionHistory: (state) => state.resolutionHistory,
};

const actions = {
  async getResolutionHistory({ commit }, { globalOrganisationID, params }) {
    const filterParams = new URLSearchParams(params);

    const res = await $http.get(
      `${getApiClientUrl()}/v3/pt/history/globalOrganisationID/${globalOrganisationID}/stats/incidents?${filterParams.toString()}`,
    );

    commit("setResolutionHistory", res.data.data);
  },
};

const mutations = {
  setResolutionHistory: (state, data) => (state.resolutionHistory = data),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
